import Detail from "./Components/detail";
import Footer from "./Components/footer";
import Header from "./Components/header";
import Home from "./Components/home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/react'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { polygon } from 'wagmi/chains'

const chains = [polygon]
const projectId = 'b35f0b2ea3caf46b366b71699d982b58'

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)

function App() {
  return (
    <>
      <WagmiConfig config={wagmiConfig}>
      <Header />
         <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/details" element={<Detail />} />
            </Routes>
          </BrowserRouter>
      </WagmiConfig>
      <Web3Modal projectId={projectId} ethereumClient={ethereumClient}

        themeMode="dark"
        explorerRecommendedWalletIds={[
          'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
          '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
          '225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f'
        ]}
        explorerExcludedWalletIds="ALL"

        themeVariables={{
          '--w3m-font-family': 'Roboto, sans-serif',
          '--w3m-accent-color': '#d500ff',
          // '--w3m-background-image-url': '/static/media/logo.919e7c6f1d09edf8a185.gif',
          '--w3m-background-border-radius': '20px',
          '--w3m-container-border-radius': '00px',
          '--w3m-logo-image-url': '/static/media/logo.919e7c6f1d09edf8a185.gif',
          '--w3m-background-color': '#d500ff',
        }}
      />
      <Footer />
    </>
  );
}

export default App;
